var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1455_14708",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1455_14708",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1455_14708",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAACtklEQVR4nO3cP47TQBiG8QfEnxMgGkRNBZfIFiwSHVegRaKh5Rb03IEK7S2WZqUV0np7ClpQKLJbrBnHY489/hI/P8nNZrwzmjeTyWcnAUmSJEmSFNsb4BrYetw5GuB1wbxmuZf4WwM8m7vjA9UAz+fsIBXIds4Oj0BqziZzf85/ruEeZLTpeka0V1LfM+dQ21d9xXCFBGMgwRhIMAYSjIEEkxNIV+Wa2+7Q2/eZtKK3MByuPWep+Rpd0RvIcDmBpNplcQ8JpqRSX4u+V4zb+ZnklcUVEoyBBGMgwRhIMAYSTIRATtkVUj+Bj8CjZYczm9EV/dBLB6WaVn8XwNsK/ebKnY8xl2auphzAVLquIZ0Bryr032fOQLLmN0ogW+Av8BV4WmEcXQwkcfwGPgOPK4ynb3y12o0/oVC7v++Jvy25v6w+EIANcJ54bIn9xUBuPAQ+AL8SbWruLwbS8gT4AvxJtN2yC+xkwfHN1W78CYVy+3sBfEu037IrKpce3yTtIlTq6hFtheS8ZG0WHN9c7cafUMhNfaIBTCXV3wb4kXjs9jgDXlYYW9f4arQbf0Khdn8WhqUnFOqa/PY+8QkvnSweyDFdXBzabvwJhSLsE/usLpDLVn8XwLsK/eZaXSAn7EK5JOYt3KqB5Hy2108u3lX6ncu97bx0EoyBBGMgwRhIMAYSTM73Q2q89dUNV0gwBhKMgQTjrwH1t6+6h7pCgjGQYAwkGAMJxkCC8bdOhvN+yJqkArmuPorD0czdQSqQ9xhKSsNubma19vvlU3IPOUYGEoyBBJNztbeLn9+agSskmJIV0maFPwFXSDAlgVg8dhtd0ZcEYkWfVlTR+86oPiv1Q2IgwRhIMFPWIV2s6AdwhQRTY4W0WdHv4QoJpkYgFo/d/qvoawRiRZ9W5R69JEmSJEkq8Q9tpIDM7P5pagAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.c9d7821f215ba551ed5692c9b9c185d2.svg";
export { ForwardRef as ReactComponent };